import axios from 'axios'
import store from './store'

const searchModule = {
  state: {
    status: '',
    searches: [],
    categories: []
  },
  mutations: {
    search_success (state, searches) {
      state.searches = searches
      state.status = 'success'
    },
    category_success (state, categories) {
      state.categories = categories
      state.status = 'success'
    },
    search_request (state) {
      state.status = 'loading'
    },
    search_error (state) {
      state.status = 'error'
    },
    add_search_success (state, search) {
      state.searches = { ...state.searches, search }
      state.status = 'success'
    }
  },
  actions: {
    getSearches ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('search_request')
        axios({ url: process.env.VUE_APP_SERVER_URL + '/users/' + store.getters.userId + '/searches', method: 'GET' })
          .then(resp => {
            const searches = resp.data.items
            commit('search_success', searches)
            resolve(resp)
          })
          .catch(err => {
            commit('search_error')
            reject(err)
          })
      })
    },
    getCategories ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('search_request')
        axios({ url: process.env.VUE_APP_SERVER_URL + '/categories', method: 'GET' })
          .then(resp => {
            const categories = resp.data.items
            commit('category_success', categories)
            resolve(resp)
          })
          .catch(err => {
            commit('search_error')
            reject(err)
          })
      })
    },
    addSearch ({ commit }, search) {
      return new Promise((resolve, reject) => {
        commit('search_request')
        console.log(search)
        axios({ url: process.env.VUE_APP_SERVER_URL + '/users/' + store.getters.userId + '/searches', data: search, method: 'POST' })
          .then(resp => {
            const search = resp.data
            commit('add_search_success', search)
            resolve(resp)
          })
          .catch(err => {
            commit('search_error')
            reject(err)
          })
      })
    }
  },
  getters: {
    userSearches: state => state.searches,
    categories: state => state.categories
  }
}

export default searchModule
